import { DEFAULT_DISCOVER_URL } from './const';

export const JOIN_TEAM_LINK = '/my-account/join-team/';
export const JOIN_TEAM_ROUTE = `${JOIN_TEAM_LINK}:hash`;

export const INSIGHTS_SERP_ROUTE = `${DEFAULT_DISCOVER_URL}/insights`;

export const DiscoverRoutes = {
  Search: `${DEFAULT_DISCOVER_URL}/search`,
  Videos: `${DEFAULT_DISCOVER_URL}/videos`,
  Pathways: `${DEFAULT_DISCOVER_URL}/pathways`,
  Glossary: `${DEFAULT_DISCOVER_URL}/glossary`,
  PathwaysDirect: '/pathways',
  VideosDirect: '/videos',
  Insights: INSIGHTS_SERP_ROUTE,
};

export const SERP_ROUTES = [
  DiscoverRoutes.Search,
  DiscoverRoutes.Videos,
  DiscoverRoutes.Pathways,
  DiscoverRoutes.Glossary,
  DiscoverRoutes.PathwaysDirect,
  DiscoverRoutes.VideosDirect,
];

export const PRICING_ROUTE = '/pricing';
export const MY_MEMBERSHIP_ROUTE = '/my-account/membership-area';
export const HOME_ROUTE = '/home';
export const ROOT_ROUTE = '/';

export const MAINTENANCE = '/maintenance';
